import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe, getToken, setToken } from '../api/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        const jwt = getToken();
        if (!jwt) {
            setUser(null);
            return;
        }

        let cancelled = false;
        setToken(jwt);

        getMe()
            .then((profile) => {
                if (cancelled) return;

                setUser({
                    token: jwt,
                    email: profile.email,
                    roles: profile.roles || [],
                    role: mapRole(profile.roles || []),
                });
            })
            .catch(() => {
                if (cancelled) return;
                setToken(null);
                setUser(null);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    function mapRole(roles = []) {
        if (roles.includes('ROLE_ADMIN')) return 'admin';
        if (roles.includes('ROLE_EDITOR')) return 'editor';
        return 'user';
    }

    async function hydrateUser(jwt) {
        setToken(jwt);

        try {
            const profile = await getMe();
            setUser({
                token: jwt,
                email: profile.email,
                roles: profile.roles || [],
                role: mapRole(profile.roles || []),
            });
        } catch (error) {
            setToken(null);
            setUser(null);
        }
    }

    async function loginUser(token) {
        await hydrateUser(token);
    }

    function logoutUser() {
        setToken(null);
        setUser(null);
    }

    return (
        <AuthContext.Provider value={{ user, loginUser, logoutUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
